import { FC } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Typography,
  Box,
} from '@mui/material';
import { Button } from '@ipc/ipc-components';
import CloseIcon from '@mui/icons-material/Close';
import { ModalProps } from './types';

const Modal: FC<ModalProps> = ({
  isOpen,
  onClose,
  title,
  description,
  children,
  maxWidth = 'sm',
  fullWidth = true,
  disableEscapeKeyDown = false,
  disableSave = false,
  onApply,
  applyText = 'Apply',
  cancelText = 'Cancel',
  ...rest
}) => {
  const handleClose = () => {
    if (!disableEscapeKeyDown) {
      onClose();
    }
  };

  const handleApply = () => {
    if (onApply) {
      onApply();
    }
    onClose();
  };

  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      maxWidth={maxWidth as | false | undefined}
      fullWidth={fullWidth}
      disableScrollLock={false}
      {...rest}
    >
      {/* Header */}
      <DialogTitle
        sx={{
          m: 0,
          p: 2,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Box>
          {title && (
            <Typography variant="h6" component="div">
              {title}
            </Typography>
          )}
          {description && (
            <Typography variant="body2" color="text.secondary">
              {description}
            </Typography>
          )}
        </Box>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: 'text.secondary',
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      {/* Content */}
      <DialogContent dividers sx={{ p: 3 }}>
        {children}
      </DialogContent>

      {/* Actions */}
      {!disableSave && (
        <DialogActions sx={{ p: 2, gap: '16px' }}>
          <Button 
            onClick={handleClose}
            variant="secondary"
            size="small"
          >
            {cancelText}
          </Button>
          <Button 
            onClick={handleApply}
            variant="primary"
            size="small"
            disabled={disableSave}
          >
            {applyText}
          </Button>
        </DialogActions>
      )}
    </Dialog>
  );
};

export default Modal;
